module.exports = __webpack_public_path__ + "5c114213/img/splash-icon.07a7c465.svg";